import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getlang } from "./Commonapis";
import CommonDropdown from "../../../common/CommonDropdown";
import { authcallApi, authcallApipost } from "../../../common/API/Api";
import Timezone from "../TimeZone";
import { getBaseUrl } from "../../../common/BaseUrl";
import useLanguage from "../../../common/useLanguage";
import { useNavigate, useParams } from "react-router-dom";
export const LanguageSelector = () => {
  // const [langcode, setLangcode] = useState(
  //   JSON.parse(localStorage.getItem("langcode")) || {
  //     Code: "en",
  //     Name: "English",
  //   }
  // );
  const navigate = useNavigate();
  const { langcode } = useLanguage();
  const { lang } = useParams();
  const { t, i18n } = useTranslation();
  let base_url = getBaseUrl();
  const [langarr, setLangarr] = useState([]);
  useEffect(() => {
    const fetchLang = async () => {
      let getlangdata = await getlang();
      if (getlangdata?.length) {
        setLangarr(getlangdata);
      }
    };
    fetchLang();
  }, []);
  useEffect(() => {
    if (langcode?.Code) {
      i18n.changeLanguage(langcode.Code);
    }
  }, [langcode, i18n]);
  // const setlang = (code) => {
  //   localStorage.setItem("langcode", JSON.stringify(code));
  //   document.body.classList.forEach((cls) => {
  //   if (cls.startsWith("lang-")) {
  //     document.body.classList.remove(cls);
  //   }
  // });
  // document.body.classList.add(`lang-${code?.Code}`);
  //   window.dispatchEvent(new Event("storage"));
  // };
  const setlang = (newLang) => {
    let lang = newLang?.Code;
    const currentPath = window.location.pathname.split("/").slice(2).join("/");
    navigate(`/${lang}/${currentPath}`);
  };
  // useEffect(() => {
  //   const handleStorageChange = () => {
  //     const newLangcode = localStorage.getItem("langcode");
  //     if (newLangcode) {
  //       setLangcode(JSON.parse(newLangcode));
  //     }
  //   };

  //   window.addEventListener("storage", handleStorageChange);
  //   return () => {
  //     window.removeEventListener("storage", handleStorageChange);
  //   };
  // }, []);

  return (
    <CommonDropdown
      label={langcode?.Name || ""}
      options={langarr}
      onSelect={(val) => {
        const selectedLang = langarr.find((lang) => lang.Name === val?.Name);
        if (selectedLang) {
          setlang(selectedLang);
        }
      }}
      labelKey="Name"
    />
  );
};

export const TimezoneSelector = (props) => {
  const { t } = useTranslation();
  //   const [updatetimezone, setUpdateTimezone] = useState(null);
  const { updatetimezone, setUpdateTimezone } = props;
  const timezoneprefrence = async (value) => {
    try {
      let postdata = {
        key: "timezoneshow",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        gettimezoneprefrence();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const gettimezoneprefrence = async () => {
    try {
      let res = await authcallApi({}, `api/preference?key=timezoneshow`, "GET");
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setUpdateTimezone(parsedValue);
      } else {
        const offset = -new Date().getTimezoneOffset(); // in minutes
        const sign = offset >= 0 ? "+" : "-";
        const absOffset = Math.abs(offset);
        const hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
        const minutes = String(absOffset % 60).padStart(2, "0");
        const timeZone = `${sign}${hours}:${minutes}`;
        let object;

        // Try to match from your list
        if (Timezone?.length) {
          object = Timezone.find((item) => item?.time === timeZone);
        }

        // If not found, fallback
        if (!object) {
          const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (tz === "Asia/Kolkata") {
            object = {
              value: "UTC +05:30",
              time: "+05:30",
              timezone: "Asia/Kolkata",
              haur: "05",
              minute: "30",
              plus: "+",
            };
          } else {
            object = {
              value: `UTC ${timeZone}`,
              time: timeZone,
              timezone: tz || "UTC",
              haur: hours,
              minute: minutes,
              plus: sign,
            };
          }
        }

        timezoneprefrence(object);
        setUpdateTimezone(object);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  // Run once on mount
  useEffect(() => {
    gettimezoneprefrence();
  }, []);

  return (
    <CommonDropdown
      label={updatetimezone?.value || ""}
      options={Timezone}
      onSelect={(val) => {
        const selectedTimezone = Timezone.find((tz) => tz.value === val?.value);
        if (selectedTimezone) {
          timezoneprefrence(selectedTimezone);
          setUpdateTimezone(selectedTimezone);
        }
      }}
      labelKey="value"
    />
  );
};

export const Settings = ({
  text,
  checked,
  showtooltip,
  classNameicMode,
  setsettingprefrence,
  soundEnabled,
}) => {
  const { t } = useTranslation();
  return (
    <div className="form-check form-switch">
      <input
        className="form-check-input"
        type="checkbox"
        checked={checked}
        onChange={(e) => {
          if (text === "Sound Control") {
            setsettingprefrence(classNameicMode, e.target.checked, showtooltip);
          } else {
            setsettingprefrence(
              classNameicMode,
              soundEnabled,
              e.target.checked,
            );
          }
        }}
      />
      <label className="form-check-label">{t(text)}</label>
    </div>
  );
};
